import { Poppins, Quicksand } from 'next/font/google'
import Image from 'next/image'
import React from 'react'
const popins = Poppins({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})
const quickSand = Quicksand({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})

export default function CourseCertificate({certificate,title,SectionRef,location,location1}) {
  return (
    <>
    <section className={`container`} ref={SectionRef}>
    <div className='whole-pdtb'>                                                                                             
    <h3 className={`fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}> <span className={`ylw-clr ${popins.className}`}> Certification Path For </span>  {title}  {location ? `in ${location}` : ''}  </h3> 
     <div className={`df gap20 mfjc projectdf mt24 mmt20`}>
        {certificate.map((items,index)=>(

        
  //       <div className={`w60p mw100p`} key={index}>
  //       {items.para.map((Para,index)=>(
  //  <p
  //               key={idx} // Unique key for each <p>
  //               className={`fs-16 mfs-15 fwb400 ${quickSand.className}`}
  //               dangerouslySetInnerHTML={{
  //                 __html:location!==undefined?Para.replace(/\${(.*?)}/g,` `+location)
  //                 :Para.replace(/in\${(.*?)}/g," ") // Replace in${...} with a space if location is not available
  //               }}
  //             ></p>
  //          ))}
  //       <h4 className={`fs-16 mfs-15 fwb700 mt20 ${quickSand.className}`}>Key Highlights</h4>
      
  //           <ul className={``}>
  //           {items.key.map((Key,index)=>(
  //       <li  key={index} style={{marginLeft: '20px', listStyleType:'disc'}} className={`fs-16 mfs-15 pdt10 fwb400 ${quickSand.className}`}>{Key}</li> 
  //          ))}
  //           </ul>
            
  //       </div>
  <div className={`w60p mw100p`} key={index}>
            {items.para.map((Para, idx) => (
              <p
                key={idx} // Unique key for each <p>
                className={`fs-16 mfs-15 fwb400 ${quickSand.className}`}
                dangerouslySetInnerHTML={{
                  __html:location!==undefined?Para.replace(/\${(.*?)}/g,` `+location)
                  :Para.replace(/in\${(.*?)}/g," ") // Replace in${...} with a space if location is not available
                }}
              ></p>
            ))}
           
          {items.key &&   
          <p className={`fs-16 mfs-15 fwb700 mt20 ${quickSand.className}`}>Key Highlights</p>}
           
            <ul>
              {items.key && items.key.map((Key, idx) => (
                <li
                  key={idx} // Unique key for each <li>
                  style={{ marginLeft: '20px', listStyleType: 'disc' }}
                  className={`fs-16 mfs-15 pdt10 fwb400 ${quickSand.className}`}
                >
                  {Key}
                </li>
              ))}
            </ul>
        </div>
        
        ))}
        <div className=''>
            <Image className={`mdn`} src={"/new-course-details/course-certificate.png"} width={505} height={357} alt={`${title} Certificate Course in ${location}`}  quality={100}/>
            <Image className='dn mdb' src={"/new-course-details/course-certificate.png"} style={{width:"100%",height:'100%'}} width={300} height={257} alt={`${title} Certificate Course in ${location}`} quality={100}/>

        </div>
     </div>
     </div>
    </section>
    </>
  )
}
